module.exports = "/assets/3dd8027aaebd92242b13f00e19f5f86b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/US.png
// module id = 3021
// module chunks = 0